export default "__VITE_ASSET__FZFzPT23__"